import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { Materia } from "../models/materia";

var httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: 'root',
})


export class MateriaService {
  private url = "api/materia";
  constructor(private http: HttpClient, @Inject("BASE_URL") baseUrl: string) {
    this.url = baseUrl + this.url;
  }

  getToken(): string {
    var tokenJson = JSON.parse(localStorage.getItem('currentUser') || '');
    return tokenJson.token;
  }

  getById(id: number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.get<any>(apiurl);
  }

  getByTemaId(id: number): Observable<any> {
    const apiurl = `${this.url}/tema/${id}`;
    return this.http.get<any>(apiurl);
  }

  getByAnoMesTemaId(ano: number, mes: number, temaId: number){
    const apiurl = `${this.url}/byAnoMesTemaId/${ano}/${mes}/${temaId}`;
    return this.http.get<any>(apiurl);
  }

  getFirst(): Observable<any> {
    const apiurl = `${this.url}/getFirst`;
    return this.http.get<any>(apiurl);
  }

  get(): Observable<any> {
    const apiurl = `${this.url}`;
    return this.http.get<any>(apiurl);
  }
  
  getPesquisaTermo(termo:string): Observable<any> {
    const apiurl = `${this.url}/pesquisa/${termo}`;
    return this.http.get<any>(apiurl);
  }


  getMateriasData(idTema:number): Observable<any> {
    const apiurl = `${this.url}/datas/${idTema}`;
    return this.http.get<any>(apiurl);
  }

  getAll(): Observable<any> {
    const apiurl = `${this.url}/all`;
    return this.http.get<any>(apiurl);
  }

  post(materia:Materia): Observable<Materia> {
    const apiurl = `${this.url}`;
    return this.http.post<Materia>(apiurl, materia,{
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }

  put(id:number, materia:Materia): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.put<Materia>(apiurl, materia, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
  delete(id:number): Observable<any> {
    const apiurl = `${this.url}/${id}`;
    return this.http.delete<any>(apiurl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
  deleteImage(id:number): Observable<any> {
    const apiurl = `${this.url}/deleteImage/${id}`;
    return this.http.get<any>(apiurl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getToken()}`,
      },
    });
  }
}
